import humanAnatomy_0 from "../../images/projects/humanAnatomy/0.PNG";
import humanAnatomy_1 from "../../images/projects/humanAnatomy/1.PNG";
import humanAnatomy_2 from "../../images/projects/humanAnatomy/2.PNG";
import humanAnatomy_3 from "../../images/projects/humanAnatomy/3.PNG";
import humanAnatomy_4 from "../../images/projects/humanAnatomy/4.PNG";
import humanAnatomy_5 from "../../images/projects/humanAnatomy/5.PNG";
import humanAnatomy_6 from "../../images/projects/humanAnatomy/6.PNG";
import humanAnatomy_7 from "../../images/projects/humanAnatomy/7.PNG";
import humanAnatomy_8 from "../../images/projects/humanAnatomy/8.PNG";

export default function humanAnatomyImages() {
  return [
    humanAnatomy_0,
    humanAnatomy_1,
    humanAnatomy_2,
    humanAnatomy_3,
    humanAnatomy_4,
    humanAnatomy_5,
    humanAnatomy_6,
    humanAnatomy_7,
    humanAnatomy_8,
  ];
}
